import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { X, Square } from "lucide-react";

const StopChargingModal = ({ isOpen, onClose, onSubmit }) => {
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setConfirmed(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    onSubmit();
    setConfirmed(false);
    onClose();
  };

  const handleClose = () => {
    setConfirmed(false);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: 420 }}>
        <div className="modal-header">
          <h3>Stop Charging</h3>
          <button className="modal-close-btn" onClick={handleClose}>
            <X size={20} />
          </button>
        </div>
        <div className="modal-body">
          <div className="charging-modal__alert charging-modal__alert--warning">
            <Square size={16} />
            <span>
              This will stop the active charging session on this charger. The vehicle will stop receiving power.
            </span>
          </div>
          <label className="charging-modal__confirm">
            <input type="checkbox" checked={confirmed} onChange={e => setConfirmed(e.target.checked)} />
            <span>I confirm I want to stop charging on this charger</span>
          </label>
        </div>
        <div className="modal-footer">
          <button className="btn-cancel" onClick={handleClose}>
            Cancel
          </button>
          <button
            className="btn-submit"
            disabled={!confirmed}
            onClick={handleSubmit}
            style={{
              opacity: !confirmed ? 0.5 : 1,
              cursor: !confirmed ? "not-allowed" : "pointer",
            }}
          >
            Stop Charging
          </button>
        </div>
      </div>
    </div>
  );
};

StopChargingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default StopChargingModal;
